// src/features/explore/ExploreFeedTabs.tsx — For You/Trending/Popular/Latest (posts view only).
import { Tabs } from '@/ui';
import { FEED_TABS } from './meta';
import type { FeedTab } from './meta';

export interface ExploreFeedTabsProps {
  active: FeedTab;
  onChange: (tab: FeedTab) => void;
}

export function ExploreFeedTabs({ active, onChange }: ExploreFeedTabsProps) {
  return (
    <Tabs
      items={FEED_TABS.map((t) => ({ value: t.id, label: t.label }))}
      value={active}
      onChange={(v) => onChange(v as FeedTab)}
    />
  );
}
